import businessTypes from '../../api/businessTypes';
import * as types from '../mutation-types';
import _ from 'lodash';

const state = {
  businessTypes: []
};

const getters = {
  BusinessTypes: state => state.businessTypes
};

const actions = {
  getBusinessTypes: _.debounce(({ commit, state }) => {
    if (state.businessTypes.length === 0) {
      businessTypes.getBusinessTypes().then(response => {
        commit(types.SET_BUSINESS_TYPES, response);
      });
    }
  }, 500)
};

const mutations = {
  [types.SET_BUSINESS_TYPES](state, businessTypes) {
    state.businessTypes = businessTypes.data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
